import { Component, OnInit } from '@angular/core';
import * as TextConstants from '../../../../constants/text.constants';
import {
  MapConfig,
  MetricType,
} from 'src/app/models/mecs-models/mecs-map-data.model';
import { CountryService } from 'src/app/services/country.service';
import { FilterRequestMecsModel } from 'src/app/models/mecs-models/filter-request-mecs.model';
import { SelectOption } from 'src/app/models/mecs-models/mecs-filter-select-options.model';
import {
  GetMecsCountryDataInformationModel,
  GetMecsCountryDataModel,
} from 'src/app/models/mecs-models/get-mecs-country-data.model';
import { MecsCountryDataService } from 'src/app/services/mecs-services/mecs-country-data.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mecs-in-depth',
  templateUrl: './mecs-in-depth.component.html',
  styleUrls: ['./mecs-in-depth.component.scss'],
})
export class MecsInDepthComponent implements OnInit {
  textConstants = TextConstants;
  showSpinner = false;
  selectedMetricType: MetricType = 'posters';
  activeOption = 'countries';
  state: boolean = false;
  isFilterContainerOpen = false;

  mapConfig: MapConfig = {
    data: [],
    metricType: this.selectedMetricType,
  };

  filterOptions: FilterRequestMecsModel = {
    startDate: null,
    endDate: null,
    countries: [],
    regions: [],
    solutions: [],
    phases: [],
  };

  selectedCountries: number[] = [];

  countrySearchText = '';

  countries: SelectOption[] = [];
  filteredCountries: SelectOption[] = [];

  mecsCountryData!: GetMecsCountryDataModel;

  expandedCountryData: { [id: number]: boolean } = {};
  expandedProjects: { [productId: number]: boolean } = {};
  selectedCountryNotes: number[] = [];

  countryDataMap: Record<number, GetMecsCountryDataInformationModel> = {};

  constructor(
    private countryService: CountryService,
    private mecsCountryDataService: MecsCountryDataService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.showSpinner = true;
    this.getInDepthCountryList();
  }

  getFilterData(e: any) {
    this.filterOptions.countries = e.countries;
    this.filterOptions.solutions = e.solutions;

    this.getInDepthCountryList();
  }

  getInDepthCountryList(): void {
    this.countryService
      .getInDepthCoyntryList(this.filterOptions)
      .subscribe((result) => {
        this.countries = result;
        this.filteredCountries = result;
        this.showSpinner = false;
      });
  }

  onSearch() {
    if (!this.countrySearchText) {
      this.filteredCountries = this.countries;
      return;
    }

    this.filteredCountries = this.countries.filter((country) =>
      country.name
        .toLowerCase()
        .startsWith(this.countrySearchText.toLowerCase())
    );
  }

  onClick(): void {
    this.isFilterContainerOpen = !this.isFilterContainerOpen;
    this.state = this.state === false ? true : false;
  }

  onInputChange(value: string): void {
    if (!value || value.trim() === '') {
      this.filteredCountries = this.countries;
    }
  }

  onRegionClick(region: any): void {
    this.filterOptions.regions = [];
    this.filterOptions.regions.push(region);

    this.getInDepthCountryList();
  }

  onCountryClick(countryId: number): void {
    const index = this.selectedCountries.indexOf(countryId);
    if (index > -1) {
      // Already selected — remove it
      this.selectedCountries.splice(index, 1);
    } else {
      // Not selected — add it
      this.selectedCountries.push(countryId);
      this.getCountryData(countryId);
    }
  }

  onNotesClick(productId: number): void {
    const index = this.selectedCountryNotes.indexOf(productId);
    if (index > -1) {
      this.selectedCountryNotes.splice(index, 1);
    } else {
      this.selectedCountryNotes.push(productId);
    }
  }

  getCountryData(country: any): void {
    this.mecsCountryDataService
      .getMecsCountryDataByCountryId(country)
      .subscribe((result) => {
        this.countryDataMap[country] = result;
        this.expandedCountryData[country] = true;

        const firstProduct = result?.products?.[0];
        if (firstProduct) {
          this.expandedProjects[firstProduct.id] = true;
        }
      });
  }

  toggleExpand(countryId: number): void {
    this.expandedCountryData[countryId] = !this.expandedCountryData[countryId];
  }

  toggleProject(productId: number): void {
    this.expandedProjects[productId] = !this.expandedProjects[productId];
  }

  getEarliestContactDate(countryId: number): string {
  const products = this.countryDataMap[countryId]?.products ?? [];

  const validDates = products
    .map(p => p.contactedDate ? new Date(p.contactedDate) : null)
    .filter((d): d is Date => d !== null);

  if (validDates.length === 0) {
    return 'TBD';
  }

  const earliest = validDates.reduce((min, curr) => curr < min ? curr : min);
  return this.datePipe.transform(earliest, 'dd.MM.yyyy') ?? 'TBD';
}
}
